import { useRef, useEffect } from 'react';
import { deepEqual } from './deep-equal';
function useDeepCompareMemoize(nextDeps) {
  var _ref$current;
  const ref = useRef();
  const isEqual = deepEqual(nextDeps !== null && nextDeps !== void 0 ? nextDeps : null, (_ref$current = ref.current) !== null && _ref$current !== void 0 ? _ref$current : null);
  if (!(ref.current && isEqual)) {
    ref.current = nextDeps;
  }
  return ref.current;
}

/**
 * Accepts a function that contains imperative, possibly effectful code.
 * Usage note: Only use deep effect if you need to deeply compare your dependencies.
 * This is usually objects which are recreated with each render (not memod). Otherwise use `useEffect` from React
 *
 * @param callback Imperative function that can return a cleanup function
 * @param deps If present, effect will only activate if the values in the list change (deep comparison)
 *
 * @see https://pushpay.atlassian.net/wiki/spaces/PPPCI/pages/694423208/Front+End+Coding+Guidelines#FrontEndCodingGuidelines-WhentouseuseDeepMemoanduseDeepEffecthooks
 */
export default function useDeepEffect(callback, deps) {
  useEffect(callback, useDeepCompareMemoize(deps));
}